import { FeaturesConfig } from '@mg/web-components/types'
import { WebConfig } from '~/config/shopConfig'
import { parseBoolean } from '~/utils/dataParsers'

export const HIDE_PRODUCT_IMAGES_KEY = 'hideProductImages'

/**
 * FTR-6737: hide product images in client center (closed e-shops with purged media).
 * Cookie first (allows local testing and forced disable with `0`), then webConfig
 * value from webadmin. Same resolution order as freeDeliveryForEmailMarketingEnabled
 * in pages/registration/index.vue.
 */
export const isHideProductImages = (
  webConfig: WebConfig | undefined,
  cookies: Record<string, string> | undefined
): boolean => {
  if (typeof cookies?.[HIDE_PRODUCT_IMAGES_KEY] !== 'undefined') {
    return parseBoolean(cookies[HIDE_PRODUCT_IMAGES_KEY], false)
  }
  return parseBoolean(webConfig?.hideProductImages, false)
}

export const getFeaturesConfig = (
  webConfig: WebConfig,
  cookies: Record<string, string> = {}
): FeaturesConfig => {
  const featuresConfig: FeaturesConfig = {}

  if (webConfig.eshopClosed) {
    featuresConfig.disableBuyAgain = true
    featuresConfig.disableDeliveryPickup = true
    featuresConfig.disablePickupPointLink = true
    featuresConfig.disableRating = true
    featuresConfig.disableProductLink = true
    featuresConfig.disableMapNavigationButton = true
    featuresConfig.useBasicHeader = true
    featuresConfig.useBasicFooter = true
    featuresConfig.disableHeaderSearch = true
    featuresConfig.disableHeaderCart = true
    featuresConfig.disableHeaderWishlist = true
    featuresConfig.disableCancelDeliveryItem = true
    featuresConfig.disableDisplayDigitalLicence = true
  }

  if (isHideProductImages(webConfig, cookies)) {
    featuresConfig.hideProductImages = true
  }

  return featuresConfig
}
